import { render } from "./ProprietiesView.vue?vue&type=template&id=69511f56&scoped=true"
import script from "./ProprietiesView.vue?vue&type=script&lang=js"
export * from "./ProprietiesView.vue?vue&type=script&lang=js"

import "./ProprietiesView.vue?vue&type=style&index=0&id=69511f56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69511f56"]])

export default __exports__